
import BForm from 'JS/components/blain-form/BForm.vue';
import BRadioGroup from 'JS/components/blain-form/BRadioGroup.vue';
import bugsnagClient from 'JS/global/bugsnag';
import CustomerVehicleRadio from './CustomerVehicleRadio.vue';
import HorizontalTextDivider from 'JS/components/HorizontalTextDivider.vue';
import SavedVehicleCard from 'JS/automotive/shared/components/SavedVehicleCard.vue';
import Spinner from 'JS/components/Spinner.vue';
import UiButton from 'JS/components/UiButton.vue';
import VehicleLookup from 'Src/js/components/automotive/vehicle-lookup/VehicleLookup.vue';
import Vue from 'vue';
import { Component, Inject, Prop } from 'vue-property-decorator';
import { CustomerVehicleService, ICustomerVehicleService } from 'JS/services/automotive/CustomerVehicleService';
import { ICustomerVehicle } from 'JS/types/Automotive';
import { ILoggerClient } from 'JS/types/Logger';

@Component({
	name: 'CustomerVehicleSelector',
	components: {
		VehicleLookup,
		SavedVehicleCard,
		UiButton,
		HorizontalTextDivider,
		CustomerVehicleRadio,
		BRadioGroup,
		BForm,
		Spinner,
	}
})
class CustomerVehicleSelector extends Vue {
	@Prop({ type: Boolean })
	showOnlyVehicle: boolean;

	@Inject({
		from: 'CustomerVehicleService',
		default: () => new CustomerVehicleService()
	})
	service: ICustomerVehicleService;

	@Inject({
		from: 'LoggerClient',
		default: () => bugsnagClient
	})
	logClient: ILoggerClient

	loading = false;
	state: 'initial' | 'show-customer-vehicles' | 'add-vehicle' = 'initial'

	customerVehicles: ICustomerVehicle[] | null = null;
	selectedVehicleId: string | number | null = null;

	addVehicle() {
		this.state = 'add-vehicle';
	}

	async selectVehicle() {
		if (!this.selectedVehicle) {
			return;
		}

		try {
			this.loading = true;
			await this.service.setPrimaryVehicle(this.selectedVehicle);
		} catch (e) {
			this.logClient.notify(e);
		} finally {
			this.loading = true;
		}

		this.$emit('select', this.selectedVehicle);
	}

	get selectedVehicle(): ICustomerVehicle | null {
		if (this.selectedVehicleId == null) {
			return null;
		}

		const id = typeof this.selectedVehicleId === 'string' ? parseInt(this.selectedVehicleId) : this.selectedVehicleId;
		if (isNaN(id)) {
			return null;
		}

		return this.customerVehicles?.find(v => v.id === id);
	}

	async getCustomerVehicles(): Promise<void> {
		try {
			this.loading = true;
			this.customerVehicles = await this.service.getVehicles();
			const minVehiclesToShow = this.showOnlyVehicle ? 0 : 1;
			this.state = this.customerVehicles?.length > minVehiclesToShow
				? 'show-customer-vehicles'
				: 'add-vehicle';
			this.loading = false;
		} catch (e) {
			this.logClient.notify(e);
		}
	}

	mounted() {
		this.getCustomerVehicles();
	}
}

export default CustomerVehicleSelector;
